/* tslint:disable */
/* eslint-disable */
/**
 * Animare Management API
 * This API provides methods for viewing and modifying animare database data for authorities. 
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PageResultOfRegistrationDto } from './PageResultOfRegistrationDto';
import {
    PageResultOfRegistrationDtoFromJSON,
    PageResultOfRegistrationDtoFromJSONTyped,
    PageResultOfRegistrationDtoToJSON,
} from './PageResultOfRegistrationDto';
import type { PossessorDto } from './PossessorDto';
import {
    PossessorDtoFromJSON,
    PossessorDtoFromJSONTyped,
    PossessorDtoToJSON,
} from './PossessorDto';

/**
 * 
 * @export
 * @interface PossessorPageResponseDto
 */
export interface PossessorPageResponseDto {
    /**
     * 
     * @type {PossessorDto}
     * @memberof PossessorPageResponseDto
     */
    possessor?: PossessorDto;
    /**
     * 
     * @type {PageResultOfRegistrationDto}
     * @memberof PossessorPageResponseDto
     */
    registrationsPage?: PageResultOfRegistrationDto;
}

/**
 * Check if a given object implements the PossessorPageResponseDto interface.
 */
export function instanceOfPossessorPageResponseDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PossessorPageResponseDtoFromJSON(json: any): PossessorPageResponseDto {
    return PossessorPageResponseDtoFromJSONTyped(json, false);
}

export function PossessorPageResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PossessorPageResponseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'possessor': !exists(json, 'possessor') ? undefined : PossessorDtoFromJSON(json['possessor']),
        'registrationsPage': !exists(json, 'registrationsPage') ? undefined : PageResultOfRegistrationDtoFromJSON(json['registrationsPage']),
    };
}

export function PossessorPageResponseDtoToJSON(value?: PossessorPageResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'possessor': PossessorDtoToJSON(value.possessor),
        'registrationsPage': PageResultOfRegistrationDtoToJSON(value.registrationsPage),
    };
}

